<!-- 在线答疑 -->
<template>
  <div class="answer-question">
    <img :src="require('@/assets/images/qxdataboard/tips.png')" class="answer-question-tips" alt="">
    <div class="answer-question-title">
      <div class="name">在线答疑</div>
      <!-- <div class="more">详情<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="answer-question-number">
      <div class="answer-question-teacher">
        <div class="number">
          <img :src="require('@/assets/images/qxdataboard/answer-img.png')" alt="">
          <span>{{answerInfo.useTchrNum}}</span>
        </div>
        <div class="name">使用教师数</div>
      </div>
      <div class="answer-question-student">
        <div class="number">
          <img :src="require('@/assets/images/qxdataboard/answer-img.png')" alt="">
          <span>{{answerInfo.useStuNum}}</span>
        </div>
        <div class="name">使用学生数</div>
      </div>
    </div>
  </div>
</template>
<script>
import {getPlatformOnlineQaStatAPI} from "@/service/api.js"
export default {
  name: 'answer-question',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    regionType:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    //学校id
    schoolId:{
      type:String,
      default:""
    }
  },
  watch:{
    startTime(){
      this.getPlatformOnlineQaStat();
    },
    endTime(){
      this.getPlatformOnlineQaStat();
    },
    schoolId(){
      this.getPlatformOnlineQaStat();
    },
    address(){
      this.getPlatformOnlineQaStat();
    }
  },
  data() {
      return {
        //在线答疑数据详情
        answerInfo:{}
      }
  },
  methods: {
    /**
     * @name 获取平台在线答疑统计
     */
     getPlatformOnlineQaStat(){
      let params={
        regionId:this.regionId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        schoolId:this.schoolId,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformOnlineQaStatAPI(params).then((res)=>{
        this.answerInfo = res;
      })
    },

  },
  mounted() {
    //获取平台在线答疑统计
    this.getPlatformOnlineQaStat();
  }
}
</script>

<style lang="scss" scoped>
.answer-question{  
  margin-top: 20px;
  background: url("~@/assets/images/qxdataboard/answer-bg.png") no-repeat ;
  background-size:100% auto;
  background-position-y: bottom;
  height: 160px;
  position: relative;
  .answer-question-tips{
    position: absolute;
    top:0;
    left: 0;
  }
  .answer-question-title{
    // color: #fff;
    // font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .answer-question-number{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 15px;
    padding-bottom: 13px;
    .answer-question-teacher,
    .answer-question-student{
      display: flex;
      flex-direction: column;
      align-items: center;
      .name{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C4D6F2;
        margin-top: 5px;
      }
      .number{
        width:70px;
        height: 78px;
        // border-radius: 50%;
        font-size: 32px;
        font-family: MaravaleExpanded;
        font-weight: normal;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img{
          position: absolute;
          bottom: 0;
          width: 100%;
        }
        span{
          position: absolute;
          bottom: 30px;
        }
        @font-face {
          font-family: MaravaleExpanded;
          src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
        }
      }
    }
  }
}
</style>